import { Accordion, Title } from '@mantine/core';
import { PropsWithChildren } from 'react';
import CustomChevron from '@/icons/chevron.svg';

interface CollapsibleSectionProps extends PropsWithChildren {
  title: string;
}

export function CollapsibleSection({
  title,
  children,
}: CollapsibleSectionProps) {
  return (
    <Accordion
      defaultValue='1'
      styles={{
        content: { margin: '16px 0', borderBottom: 'none', padding: 4 },
        control: { padding: 0 },
      }}
    >
      <Accordion.Item value='1'>
        <Accordion.Control
          chevron={<CustomChevron style={{ width: 20, height: 20 }} />}
        >
          <Title order={6}>{title}</Title>
        </Accordion.Control>
        <Accordion.Panel m={0}>{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
